/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Header_On_Free_PlanInputs */



/**
* | output |
* | --- |
* | "You're on the Free plan" |
*
* @param {Pricing_Header_On_Free_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_header_on_free_plan = /** @type {((inputs?: Pricing_Header_On_Free_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Header_On_Free_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie nutzen den kostenlosen Tarif")
	return /** @type {LocalizedString} */ ("You're on the Free plan")
});